import { SessionMode } from 'enums/SessionMode';
import { SessionTaggingState } from 'enums/SessionTaggingState';
import { SessionType } from 'enums/SessionType';
import { IApiGameLevel, IApiLeague } from 'interfaces/team/IApiScheduleResponse';

export interface IApiArchiveSessionModel {
  sessionId: string;
  owningOrganizationId: string;
  time: string;
  league: IApiLeague;
  level: IApiGameLevel;
  homeTeam: ISessionTeam;
  awayTeam: ISessionTeam;
  sessionTaggingState: ISessionTaggingState;
  sessionModeState: ISessionModeState;
  sessionType: SessionType;
  systemId: string;
  uploadStatus: UploadStatus;
  uploadState?: IUploadState;
  field: { id: string; name: string; shortName: string };
  isOperatorlessTaggingEnabled: boolean;
}

export enum UploadStatus {
  Unknown = 'Unknown',
  Uploaded = 'Uploaded',
  InProgress = 'InProgress',
  NotApplicable = 'NotApplicable',
}

interface ISessionTaggingState {
  state: SessionTaggingState;
  initialLineupSetUtc?: string;
  initialLineupSetLocal?: string;
  sessionApprovedByTaggerUtc?: string;
  sessionApprovedByTaggerLocal?: string;
  playCountAfterApproval?: number;
}

interface ISessionModeState {
  sessionStartedUtc: string;
  sessionStartedLocal: string;
  sessionEndedUtc: string;
  sessionEndedLocal: string;
  state: SessionMode;
}

interface ISessionTeam {
  id: string;
  name: string;
  organizationId: string | null;
}

export interface IUploadState {
  metadataUploadStatus: UploadStatus;
  playVideoUploadStatus: UploadStatus;
  compositeMediaUploadStatus: UploadStatus;
  ppImagesUploadStatus: UploadStatus;
  stmfUploadStatus: UploadStatus;
  isInternetConnectionAvailable: boolean;
}
